import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export function Faq({ items, title = "Common questions" }) {
  return (
    <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6" data-testid="faq-section">
      <h2 className="mb-8 font-heading text-3xl font-extrabold tracking-tight">{title}</h2>
      <Accordion type="single" collapsible className="w-full">
        {items.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-heading text-base font-bold">{f.q}</AccordionTrigger>
            <AccordionContent className="text-[15px] leading-relaxed text-muted-foreground">
              {f.a}
              {f.list && (
                <ul className="mt-3 list-disc space-y-1.5 pl-5">
                  {f.list.map((li, idx) => <li key={idx}>{li}</li>)}
                </ul>
              )}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
